$(window).trigger('resize').trigger('scroll');

$(function () {
    var $filterSelect = $('#FilterSelect'),
        $sortSelect = $('#SortSelect'),
        $container = $('#listContainer:not(.search-results-ul)');

    $container.mixItUp();

    $filterSelect.on('change', function () {
        $container.mixItUp('filter', this.value);
    });

    $sortSelect.on('change', function () {
        $container.mixItUp('sort', this.value);
    });

    $('.msMenuToggle').on('click', function () {
        $('.msMenu').toggleClass('open');
    });
});

function buttonize($elm, on) {
    'use strict';

    if (typeof on === "undefined") {
        on = true;
    }

    let $icon = $elm.find('.fa');

    if (on) {
        $icon.data('original-class', $icon.attr('class')).attr('class', 'fa fa-spinner fa-spin');
        $elm.attr('disabled', true);
    }
    else {
        if ($icon.data('original-class')) {
            $icon.attr('class', $icon.data('original-class'));
        }
        $elm.attr('disabled', false);
    }
}


$(document).ready(function () {

    var $place = $('.place_name');
    if ($place.length) {
        $place.text(locationService.getLast('Ikke valgt'));
    }

    //getTop5();

    if ($(".js-select2-multiple").length) {
        $(".js-select2-multiple").select2();
    }

    var cloneCount = 1;
    $("a.addListItem").click(function () {
        $("#dep").clone().attr('id', 'id' + cloneCount++).insertAfter("#dep");
    });

    $("a.addServiceItem").click(function () {
        $("#serviceItem").clone().attr('id', 'id' + cloneCount++).insertAfter("#serviceItem");
    });

    $('#content').redactor();

    $("#uploadTrigger").click(function () {
        $("#uploadFile").click();
    });

    $('#rating').barrating({
        theme: 'fontawesome-stars',
        onSelect: function (value, text, event) {
            $('input[name="rating"]').val(value);
        }
    });


    if ($('#slideshow').length > 0 && !$('#slideshow').hasClass('static')) {
        $('#slideshow').argoslide({
            navIconPrev: 'fa fa-angle-left',
            navIconNext: 'fa fa-angle-right'
        });
    }

    $('.menuToggle').on('click', function () {
        $('#mainNav').toggleClass('open');
    });

    $('#searchToggle').on('click', function () {
        $('.advancedSearch').toggleClass('open');
        $('#searchToggle').toggleClass('active');
    });

    $('.moreRatingsToggle a').on('click', function () {
        $('#companyRatings').toggleClass('open');
        $('.moreRatingsToggle').toggleClass('active');
    });

    $('.readMoreToggle a').on('click', function () {
        $('.contentBox').toggleClass('open');
        $('.linkBox').toggleClass('active');
    });

    // jPUSHmenu

    $(document).ready(function ($) {
        $('.toggle-menu').jPushMenu();
    });

    // -------

    $('.companyServicesList>.defaultServices>ul>li>a.moreToggle, .companyServicesList>.customServices>ul>li>a.moreToggle').click(function () {
        var elem = $(this).parent().children('.serviceInfoBox');

        //Check if this one is allready open
        if (elem.hasClass('open')) {
            elem.removeClass('open');

        } else {
            //It is not already open
            $('.companyServicesList>.defaultServices>ul>li>div.serviceInfoBox, .companyServicesList>.customServices>ul>li>div.serviceInfoBox').removeClass('open');
            elem.addClass('open');

        }
    });

    $('#branchList').find('li a.moreToggle').on('click', function () {
        var b = $(this).parents('li');
        b.find('ul').toggleClass('open');
        b.find('a.moreToggle').toggleClass('active');
    });

    $('div.fadeIn').hide().delay(500).fadeIn(1000).removeClass('hidden');

    $('a[href$=".pdf"]').addClass("pdf");
    $('a[href$=".doc"]').addClass("doc");
    $('a[href$=".docx"]').addClass("doc");
    $('a[href$=".xls"]').addClass("xls");
    $('a[href$=".xlsx"]').addClass("xls");


    // SLIDESHOW Bakgrunnsbilde
    $(function () {
        $("#frontBanner").each(function () {
            var d = $(this), i = d.find('img').first();
            if (i.length) {
                d.css({
                    'background': 'url(' + i.attr('src') + ') no-repeat'
                });
                i.remove();
            }
        });
    });


    // Scroll
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st >= 10) {
            $('#top').addClass('minimized');
            $('#subpageBanner').addClass('minimized');
        } else {
            $('#top').removeClass('minimized');
            $('#subpageBanner').removeClass('minimized');
        }
    });
    // Add this class for when the website loads in the middle of the page
    if ($(window).scrollTop() >= 10) {
        $('#top').addClass('minimized');
        $('#subpageBanner').addClass('minimized');
    }

    $(window).scroll(function () {
        $(".scrollOut").css({
            'opacity': 1 - (($(this).scrollTop()) / 250)
        });
    });

    if ($('.bxslider').length) {
        $('.bxslider').bxSlider();
    }


    $(function () {
        $('#listContainer:not(.search-results-ul)').mixItUp({
            controls: {
                enable: true
            },
            selectors: {
                filter: 'none' // tell MixItUp not to look for '.filter' buttons
            },
            load: {
                filter: 'all'
            }
        });
    });

    function formatTitle(title, currentArray, currentIndex, currentOpts) {
        return '<div id="galleryCaption-title"><span><a href="javascript:;" onclick="$.fancybox.close();"><img src="/data/closelabel.gif" /></a></span>' + (title && title.length ? '<b>' + title + '</b>' : '') + 'Image ' + (currentIndex + 1) + ' of ' + currentArray.length + '</div>';
    }


    initChocolat($('.thumbBoxes'));



    /*
        $(".galleryCaption").fancybox({
            'showCloseButton': false,
            'titlePosition': 'over',
            'titleFormat': formatTitle
        });

        // Initierer fancybox om brukeren ikke er på touch skjerm
        if (!$('body').hasClass('touch')) {

            $('.fancybox').fancybox({
                padding: 10,
                scrolling: 'yes',
                nextEffect: 'fade',
                prevEffect: 'fade',
                titlePosition: 'over',
                helpers: {
                    overlay: {
                        locked: false
                    },
                    title: {
                        type: 'over'
                    }
                }
            });
        }

    */
    $('#locationModal select[name="fylke"]').trigger('change.populate-kommune-modal');

    $('#locationModal select[name="kommune"]').trigger('change.populate-sted-modal');

});


// Quicktech

// Ignore anchors with '#' only
$('body').on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
});

// disable search button if no parameters
$('.is-search-input, select[name="filters"]').on('change.ajax-search', function () {
    var hasValue = $('.is-search-input,select[name="filters"]').filter(function () {
        return this.value;
    }).length;

    $('.searchButton button')[hasValue ? 'removeAttr' : 'attr']('disabled', 'disabled');
});

/*
/\/Check when the user checks the checkbox for search in his area.
$sac.on('change.search', function () {
    if ($(this).is(":checked")) {
        $('.searchButton button')['removeAttr']('disabled');
        $sac.siblings('[name="citypart[]"]').removeAttr('disabled').val(locationService.getCitypart());
        $sac.siblings('[name="places[]"]').removeAttr('disabled').val(locationService.getPlace());
        $sac.siblings('[name="areas[]"]').removeAttr('disabled').val(locationService.getArea());

        $.each($('select.is-search-input'), function (index, elem) {
            $(this).val('');
        });
    } else {
        var inputs = $sac.siblings();
        $.each($(inputs), function (el, val) {
            $(val).attr('disabled', 'true').val('');
        });
        /\/Check the select boxes to see if there is any value.
        $('.is-search-input, select[name="filters"]').trigger('change.ajax-search');
    }
});
*/

//Check if the user press any key on the search input field.
$('input.is-search-input').on('input.ajax-search', function () {
    var hasValue = $('input.is-search-input').val().length;
    $('.searchButton button')[hasValue ? 'removeAttr' : 'attr']('disabled', 'disabled');
});

// Changing 'fylke' <select> elements display related 'Kommuner' only
$('.fylke_select').change(function () {
    var select = $(this).parents('.advancedSearch').find('.kommune_select'),
        fylke_name = $(this).val();
    select.empty();

    if (!fylke_name) {
        select.append(select.siblings('select').find('option').clone());
        return;
    }

    select.append(select.siblings('select').find("option[data-for='*'],option[data-for='" + fylke_name + "']").clone());

});

$('.kommune_select').on('change.populate-sted', function () {

    var select = $(this).parents('.advancedSearch').find('.townSelect .sted_select'),
        sted_name = $(this).val();
    select.empty();

    if (!sted_name) {
        select.append(select.siblings('select').find('option').clone());
        return;
    }

    select.append(select.siblings('select').find("option[data-for='*'],option[data-for='" + sted_name + "']").clone());
});

$('#locationModal select[name="fylke"]').on('change.populate-kommune-modal', function () {
    var select = $('#locationModal select[name="kommune"]'),
        fylke_name = $(this).val();
    select.empty();

    if (!fylke_name) {
        select.append(select.siblings('select').find('option').clone());
        return;
    }

    select.append(select.siblings('select').find("option[data-for='*'],option[data-for='" + fylke_name + "']").clone());

});

$('#locationModal select[name="kommune"]').on('change.populate-sted-modal', function () {

    let select = $('#locationModal select[name="sted"]').attr('disabled', true),
        kommune_name = $(this).val();
    select.empty();

    if (!kommune_name) {
        select.append(select.siblings('select').find('option').clone());
        return;
    }
    let steder = select.siblings('select')
        .find("option[data-for='*'],option[data-for='" + kommune_name + "']")
        .clone();

    if (steder.length > 1) {
        select.append(steder).attr('disabled', false);
    }
});

/*
$('.resetSearch').on('click.reset-search', function () {
    $.each($('.is-search-input'), function (index, element) {
        $(this).val('');
    });

    $sac.prop('checked', false);
    $sac.trigger('change.search');
});
*/

$('.searchBoxFields').find('form').on('submit', function () {
    $(this).find('button[type="submit"]').click();
});

// Cookie handling
function setCookie(cname, cvalue, exdays) {
    'use strict';

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    'use strict';

    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


// Filtering load handler
function _initCheckFilters() {
    'use strict';

/*
    let $ya = $('.searchBoxLink input[name="yourArea"]');

    if ($ya.is(":checked")) {
        $.each($('select.is-search-input'), function (index, elem) {
            $(this).val('');
        });

        $ya.siblings('[name="citypart[]"]').removeAttr('disabled').val(locationService.getCitypart());
        $ya.siblings('[name="places[]"]').removeAttr('disabled').val(locationService.getPlace());
        $ya.siblings('[name="areas[]"]').removeAttr('disabled').val(locationService.getArea());

    }
*/
    let hasValue = $('.is-search-input').filter(function () {
        return this.value;
    }).length || $('input[name="yourArea"]').is(':checked');

    $('.searchButton button')[hasValue ? 'removeAttr' : 'attr']('disabled', 'disabled');
}

_initCheckFilters(); //Run the function after page loads.


const initGoogleMaps = () => {
    return  new Promise((resolve, reject) => {
        if(typeof google !== 'undefined') {
            resolve(google.maps);
        }

        window.addEventListener('load',function(){
            if(typeof google !== 'undefined') {
                resolve(google.maps);
            }
            else {
                reject('No google maps');
            }
        });
    });
};

initGoogleMaps().catch(e => {});

function scrollWindowTo(element) {
    'use strict';

    var pos = element.offset().top - 30;

    if ($(window).width() >= 1094) {
        pos -= $('header').outerHeight();
    }

    $('html, body').animate({scrollTop: pos}, 500);
}

function confirmModal(title, message, callback) {
    'use strict';

    var $modal = $('#confirmationModal');


    $modal.foundation('reveal', 'open');

    $modal.find('h2:first').html(title);
    $modal.find('p:first').html(message);

    $modal.find('.yes').on('click.confirm', function () {
        $('#confirmationModal').foundation('reveal', 'close');
        callback.call();
    });

    $modal.find('.alert').on('click.close', function () {
        $('#confirmationModal').foundation('reveal', 'close');
    });
}